import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

export default function ({ className = "py-5 py-md-6", theme = "light" }) {
  return (
    <div className={cn(className)} data-bs-theme={theme}>
      <Container fluid="md">
        <Row>
          <Col xs={12} md={12}>
            <iframe
              width="100%"
              height="600"
              style={{ border: "unset" }}
              src="https://www.evertreen.com/forest/66608ed3c286b?iframe=1"
            ></iframe>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
